<template>
  <div>
    <b-jumbotron :header="site.title" lead="Quickly add metadata to images">
      <p>This is a very early alpha version.</p>
      <b-button variant="primary" to="/about">About {{site.title}}</b-button>
    </b-jumbotron>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({ site: "site" })
  }
};
</script>

<style>
</style>